// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5556":"56dc22ab","6368":"56dc22ab"}[chunkId] + ".chunk.css";
};